import { NAME } from './constants';
import { menu } from './menu';
import { router } from './router';
import { VozidloPujcovna } from './vozidloPujcovna';
import { Zapujcky } from './zapujcka';
import { PredmetPujcovna } from './ostatniPredmety';

export const Pujcovna = {
	name: NAME,
	menu,
	router,
	VozidloPujcovna,
	Zapujcky,
	PredmetPujcovna,
};
